// Standard suffixes
export const SUFFIXES = ['Jr', 'Sr', 'II', 'III', 'IV', 'V'];

// CMS standard relationship codes
export const RELATIONSHIP_CODES = [
  { code: '01', description: 'Self' },
  { code: '02', description: 'Spouse' },
  { code: '03', description: 'Natural Child' },
  { code: '04', description: 'Natural Child - Insured Financial Responsibility' },
  { code: '05', description: 'Stepchild' },
  { code: '06', description: 'Foster Child' },
  { code: '07', description: 'Ward of the Court' },
  { code: '08', description: 'Employee' },
  { code: '09', description: 'Unknown' },
  { code: '10', description: 'Handicapped Dependent' },
  { code: '11', description: 'Organ Donor' },
  { code: '12', description: 'Cadaver Donor' },
  { code: '13', description: 'Grandchild' },
  { code: '14', description: 'Niece/Nephew' },
  { code: '15', description: 'Injured Plaintiff' },
  { code: '16', description: 'Sponsored Dependent' },
  { code: '17', description: 'Minor Dependent of a Minor Dependent' },
  { code: '18', description: 'Parent' },
  { code: '19', description: 'Grandparent' },
  { code: '20', description: 'Domestic Partner' },
  { code: '21', description: 'Other Relationship' }
];

// US State abbreviations
export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
  'DC', 'PR', 'VI', 'GU', 'AS', 'MP'
];
